import React, { Component } from 'react';
import { Localization } from '../localization/index';
import { PakleanImages } from '../images/index';
import { Colors } from '../colors/index';

import Modal from 'react-modal'
import { ClipLoader } from 'react-spinners';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import DatePicker from "react-datepicker2";
import moment from 'moment-jalaali'




class OrdersByTimeAndRegion extends Component {


    constructor(props) {
        super(props)
    }

    state = {

        fetchHours: ['8 - 10', '10 - 12', '12 - 14', '14 - 16', '16 - 18', '18 - 20'],
        deliverHours: ['8 - 12', '12 - 16', '16 - 20', 'غیره'],
        regions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 'نامشخص'],
        fetchData: [],
        deliverData: [],
        selectedDate: moment(),
        selectedTs: undefined,
        isLoading: false,

    }


    onDateChanged = (date) => {
        let d = new Date(date._d)
        d.setHours(0)
        console.log(d.getTime())
        this.setState({ selectedDate: date, selectedTs: d.getTime() }, this.getData)

    }



    getData = () => {

        this.setState({ isLoading: true })

        // let oldUrl = 'http://panel.api.paklean.com/puser/timeslices/statistics/' + this.state.selectedTs

        fetch('https://pnl.api.paklean.com/puser/stat/pickup1day/' + this.state.selectedTs, {
            method: 'GET',
            headers: {
                Authorization: global.authorization,
            },

        }).then(response => response.json())
            .then((responseJson) => {

                if (responseJson.code === 200) {

                    this.setState({ fetchData: responseJson.orders }, this.getDeliverData)

                } else {
                    this.setState({ isLoading: false, });
                    toast(Localization.Farsi.error)
                }

            }).catch((err) => {
                this.setState({ isLoading: false, });
                toast(Localization.Farsi.error)
            })

    }


    getDeliverData = () => {

        fetch('https://pnl.api.paklean.com/puser/stat/delivery1day/' + this.state.selectedTs, {
            method: 'GET',
            headers: {
                Authorization: global.authorization,
            },

        }).then(response => response.json())
            .then((responseJson) => {
                this.setState({ isLoading: false, });

                if (responseJson.code === 200) {

                    this.setState({ deliverData: responseJson.orders })

                } else {
                    toast(Localization.Farsi.error)
                }

            }).catch((err) => {
                this.setState({ isLoading: false, });
                toast(Localization.Farsi.error)
            })

    }




    renderColumns = (array, index) => {

        let columnData = []


        if (array != null) {
            for (let i = 0; i < array.length; i++) {

                let name = array[i].driverName;
                let count = array[i].regionStat[index]

                if (count > 0)
                    columnData.push(name + ': ' + count)
            }

        }

        return (
            <td>
                {columnData.map((data, index) => (
                    <tr style={{ backgroundColor: 'transparent' }}>
                        <td style={{ border: 'none' }} >{data}</td>
                    </tr>
                )
                )}
            </td>
        )


    }


    // makeDataArray = () => {

    //     let newData = []
    //     for (let i = 0; i < this.state.hours.length; i++) {
    //         let row = [this.state.hours[i]];
    //         for (let j = 0; j < this.state.data.length; j++) {
    //             row.push(this.state.data[j][i])
    //         }
    //         newData.push(row)
    //     }

    //     console.log(newData)
    //     this.setState({ data: newData })

    // }

    render() {
        return (

            <div style={styles.container}>
                <div style={styles.content}>

                    <DatePicker
                        isGregorian={false}
                        timePicker={false}
                        value={this.state.selectedDate}
                        onChange={this.onDateChanged}
                    />


                    <div style={{ overflowX: 'auto', width: '100%', direction:'rtl' }}>

                        <table style={{ width: '100%', }} >
                            <tbody >
                                <tr>
                                    <th style={{ color: Colors.PrimaryColor }}>دریافت</th>
                                    {this.state.regions.map((region, index) =>
                                        <th key={index} >منطقه {region}</th>)}
                                </tr>

                                {this.state.fetchData ? this.state.fetchData.map((row, outerIndex) =>
                                    <tr key={outerIndex}>
                                        <th>{this.state.fetchHours[outerIndex]}</th>
                                        {this.state.regions.map((region, index) => this.renderColumns(this.state.fetchData[outerIndex], index))}
                                    </tr>
                                )
                                    :
                                    null
                                }
                            </tbody>
                        </table>

                        <div style={{ backgroundColor: Colors.PrimaryColor, height: 1, width: '100%', marginTop: 10, marginBottom: 10, }} />


                        <table style={{ width: '100%', }} >
                            <tbody  >
                                <tr>
                                    <th style={{ color: Colors.PrimaryColor }}>ارسال</th>
                                    {this.state.regions.map((region, index) =>
                                        <th key={index} >منطقه {region}</th>)}
                                </tr>

                                {this.state.deliverData ? this.state.deliverData.map((row, outerIndex) =>
                                    <tr key={outerIndex}>
                                        <th>{this.state.deliverHours[outerIndex]}</th>
                                        {this.state.regions.map((region, index) => this.renderColumns(this.state.deliverData[outerIndex], index))}
                                    </tr>
                                )
                                    :
                                    null
                                }
                            </tbody>
                        </table>

                    </div>

                </div>

                <ToastContainer
                    closeButton={false}
                    hideProgressBar
                    rtl
                    style={{ textAlign: 'center', color: 'black', }}
                    autoClose={2000}
                    pauseOnFocusLoss={false}
                    position="bottom-center" />


                <Modal
                    isOpen={this.state.isLoading}
                    style={styles.spinnerStyle} >
                    <div style={{
                        display: 'flex', justifyContent: 'center',
                        WebkitBoxPack: 'center', WebkitBoxPack: 'center', WebkitBoxAlign: 'center', alignItems: 'center', WebkitBoxAlign: 'center',
                    }}>
                        <ClipLoader
                            size={100}
                            color={Colors.SpinnerColor}
                            loading={this.state.isLoading}
                        />
                    </div>

                </Modal>

            </div >


        );
    }
}



export default OrdersByTimeAndRegion

const styles = {

    modalStyles: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            zIndex: 10,
        },
    },

    modalStylesNotComplete: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            padding: 0,
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            zIndex: 10,
            backgroundColor: "rgba(0, 0, 0, 0.85)",
        },
    }
    ,
    spinnerStyle: {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            border: 'none',
            outline: 'none',
            transform: 'translate(-50%, -50%)',
            backgroundColor: 'transparent'
        },
        overlay: {
            zIndex: 10,
        },
    },

    content: {

        // position: 'fixed',
        padding: 10,
        width: '100%',
        height: '100%',
        display: 'flex',
        WebkitBoxOrient: 'vertical', flexDirection: 'column',
        alignItems: 'center', WebkitBoxAlign: 'center',
    },

    container: {

        display: '-webkit-box',
        display: '-moz-box',
        display: '-ms-flexbox',
        display: '-webkit-flex',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 0,
        flexBasis: 'auto',
        justifyContent: 'stretch',
        alignItems: 'flex-start',
        WebkitBoxOrient: 'vertical',
        WebkitBoxDirection: 'normal',
        WebkitFlexDirection: 'column',
        WebkitFlexGrow: 1,
        WebkitFlexShrink: 0,
        WebkitFlexBasis: 'auto',
        WebkitBoxPack: 'stretch',
        WebkitJustifyContent: 'stretch',
        WebkitBoxAlign: 'start',
        WebkitAlignItems: 'flex-start',

    },
};

